module.exports = __webpack_public_path__ + "img/diamante-black.86b38c51.png";